<script lang="ts" setup>
import HowToGuide from "@/components/organisms/common/HowToGuide/HowToGuide.vue";
import { firstBootStore } from "@/store/first-boot";
import { useCustomRouter } from "@/utils/router";

const { replaceIgnoreError } = useCustomRouter();

const onClose = async () => {
  firstBootStore.completeFirstBoot();
  await replaceIgnoreError({ name: "Welcome" });
};
</script>

<template>
  <HowToGuide @close="onClose" />
</template>
